import { render, staticRenderFns } from "./ClientAveragePaymentDurationReportList.vue?vue&type=template&id=72686ed8&"
import script from "./ClientAveragePaymentDurationReportList.vue?vue&type=script&lang=js&"
export * from "./ClientAveragePaymentDurationReportList.vue?vue&type=script&lang=js&"
import style0 from "./ClientAveragePaymentDurationReportList.vue?vue&type=style&index=0&id=72686ed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports